export default "__VITE_ASSET__DJOpOPFZ__"